import React, {FC} from 'react';

import './index.css';

interface FooterProps {
  setIsEmailSaved: (isSaved: boolean) => void;
  email: string;
}

const Footer: FC<FooterProps> = props => {
  const {setIsEmailSaved, email} = props;
  return (
    <div className="Footer">
      <p className="Footer-login">
        Logged in as: <b>{email}</b>{' '}
        <span onClick={() => setIsEmailSaved(false)}>Change</span>
      </p>
      <p>
        <b>Powered by Macmillan</b>
      </p>
      <p>Platform Development • {new Date().getFullYear()}</p>
    </div>
  );
};

export default Footer;
